import { Globe } from "lucide-react";
import { useTranslation } from "../../i18n/LanguageContext";

export default function LangToggle({ compact = false }) {
  const { lang, setLang } = useTranslation();

  return (
    <div
      data-testid="lang-toggle"
      className={`inline-flex items-center rounded-full border border-white/15 bg-white/[0.03] backdrop-blur-md ${
        compact ? "p-0.5 gap-0.5" : "p-1 gap-1"
      }`}
    >
      <Globe
        size={12}
        className={`text-[#0a0a0a] shrink-0 ${compact ? "ml-1.5 mr-0.5" : "ml-2 mr-1"}`}
        strokeWidth={1.5}
      />
      {["hu", "ru"].map((code) => (
        <button
          key={code}
          data-testid={`lang-${code}`}
          onClick={() => setLang(code)}
          className={`rounded-full font-semibold transition-all duration-300 ${
            compact
              ? "px-2 py-1 text-[10px] tracking-[0.16em]"
              : "px-2.5 py-1.5 text-[11px] tracking-[0.18em]"
          } uppercase ${
            lang === code
              ? "bg-gradient-to-r from-[#0a0a0a] to-[#83588f] text-[#ebe2f5]"
              : "text-[#594f5a] hover:text-[#1a1a1a]"
          }`}
          aria-pressed={lang === code}
        >
          {code === "hu" ? "HU" : "RU"}
        </button>
      ))}
    </div>
  );
}
